import { computed, Signal } from '@angular/core';

import { injectPurchaseOrderQuery } from '@models/purchase-order/purchase-order-list-query';

import { listPOQuery } from '@shared/services/gql.service';

export interface BalanceSheetPoAttributeContext {
  poOptions: Signal<{ label: string; value: string }[]>;
}

export function useBalanceSheetPoAttributeContext({ vendorId }: { vendorId: Signal<string> }) {
  // Fetch all POs
  const purchaseOrderQuery = injectPurchaseOrderQuery();

  // Filter and map POs by vendorId
  const poOptions = computed(() => {
    const data = purchaseOrderQuery.data() as listPOQuery[] | null;

    if (!data) return [];
    const vId = vendorId();

    return data
      .filter((po) => po.organization?.id === vId)
      .map((po) => ({ label: po.po_number, value: po.po_number }));
  });

  return {
    poOptions,
  };
}
